/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentStats
 */
export interface DocumentStats {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    filesize?: number;
    /**
     * 
     */
    page_count?: number;
}

/**
 * Check if a given object implements the DocumentStats interface.
 */
export function instanceOfDocumentStats(value: object): value is DocumentStats {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DocumentStatsFromJSON(json: any): DocumentStats {
    return DocumentStatsFromJSONTyped(json, false);
}

export function DocumentStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentStats {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'filesize': json['filesize'] == null ? undefined : json['filesize'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
    };
}

export function DocumentStatsToJSON(json: any): DocumentStats {
    return DocumentStatsToJSONTyped(json, false);
}

export function DocumentStatsToJSONTyped(value?: DocumentStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'filesize': value['filesize'],
        'page_count': value['page_count'],
    };
}

